import styled from 'styled-components';

const AppCardNameWrapper = styled.div`
  position: relative;
  white-space: nowrap;
  overflow: hidden;

  &:after {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    width: 40px;
    z-index: 2;
    background: linear-gradient(
      to right,
      rgba(255, 255, 255, 0),
      rgba(255, 255, 255, 0.8) 50%,
      rgba(255, 255, 255, 1) 80%
    );
  }
`;

export { AppCardNameWrapper };
